export const INSPECTION_ITEM_STATUS_SVG_ICONS_NAMESPACE =
  'inspection-item-status';
